
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"11","cy":"11","r":"11","fill":"#FF594F"}}),_c('path',{attrs:{"d":"M6.42188 15.9048C6.50391 15.9868 6.60189 16.0415 6.71582 16.0688C6.82975 16.1007 6.94141 16.1007 7.05078 16.0688C7.16471 16.0415 7.26497 15.9868 7.35156 15.9048L11.3984 11.8511L15.459 15.9048C15.582 16.0278 15.7347 16.0894 15.917 16.0894C16.0993 16.0939 16.2542 16.0324 16.3818 15.9048C16.5094 15.7772 16.5732 15.6222 16.5732 15.4399C16.5732 15.2531 16.5117 15.0981 16.3887 14.9751L12.3281 10.9214L16.3887 6.87451C16.5117 6.75146 16.5732 6.59652 16.5732 6.40967C16.5732 6.22282 16.5094 6.06787 16.3818 5.94482C16.2542 5.82178 16.0993 5.76025 15.917 5.76025C15.7347 5.76025 15.582 5.82178 15.459 5.94482L11.3984 9.99854L7.35156 5.94482C7.26497 5.86279 7.16471 5.80811 7.05078 5.78076C6.94141 5.74886 6.82975 5.74658 6.71582 5.77393C6.60189 5.80127 6.50391 5.85824 6.42188 5.94482C6.33984 6.03141 6.28516 6.13167 6.25781 6.24561C6.23047 6.35498 6.23047 6.46663 6.25781 6.58057C6.28516 6.6945 6.33984 6.79248 6.42188 6.87451L10.4688 10.9214L6.42188 14.9751C6.33984 15.0571 6.28288 15.1551 6.25098 15.269C6.22363 15.383 6.22363 15.4969 6.25098 15.6108C6.27832 15.7248 6.33529 15.8228 6.42188 15.9048Z","fill":"white"}})])
          )
        }
      }
    